import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { ButtonModule, CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import {
  DocumentEditorAllModule,
  DocumentEditorContainerAllModule,
  EditorService,
  SelectionService,
  ToolbarService,
} from '@syncfusion/ej2-angular-documenteditor';
import {
  ComboBoxModule,
  DropDownListAllModule,
  DropDownListModule,
  MultiSelectAllModule,
} from '@syncfusion/ej2-angular-dropdowns';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import {
  ColorPickerModule,
  NumericTextBoxModule,
  SliderModule,
} from '@syncfusion/ej2-angular-inputs';
import { ListViewAllModule, ListViewModule } from '@syncfusion/ej2-angular-lists';
import { TabModule, ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { DialogModule, TooltipModule } from '@syncfusion/ej2-angular-popups';
import { DropDownButtonModule, SplitButtonModule } from '@syncfusion/ej2-angular-splitbuttons';

import { MaterialModule } from 'src/app/Shared/material.module';
import { TemplateViewerComponent } from './template-viewer/template-viewer.component';

/**
 * This is using for set the route JSON
 */
const routes: Routes = [
  {
    path: '',
    component: TemplateViewerComponent,
  },
];

@NgModule({
  declarations: [TemplateViewerComponent],
  exports: [TemplateViewerComponent, DragDropModule],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // RouterModule.forChild(routes),
    DropDownListAllModule,
    DragDropModule,
    ColorPickerModule,
    SplitButtonModule,
    SliderModule,
    NumericTextBoxModule,
    DropDownButtonModule,
    DropDownListModule,
    ComboBoxModule,
    MultiSelectAllModule,
    DocumentEditorAllModule,
    DocumentEditorContainerAllModule,
    ListViewAllModule,
    CheckBoxModule,
    ButtonModule,
    DialogModule,
    TooltipModule,
    GridModule,
    ToolbarModule,
    TabModule,
    ListViewModule,
    MaterialModule,
  ],
  providers: [
    ToolbarService,
    EditorService,
    SelectionService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class TemplateViewerModule {}
